import React from "react";
import { MaterialChooser } from "./MaterialChooser";
import { ShapeChooser } from "./ShapeChooser";
import { Dialog, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const chooser = (props) => {
  switch (props?.type) {
    case "shape":
      return <ShapeChooser {...props} />;
    case "material":
      return <MaterialChooser {...props} />;
  }

  return null;
};

const FullScreenDialog = (props) => {
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return isFullScreen ? (
    <Dialog open={true} fullScreen>
      {chooser(props)}
    </Dialog>
  ) : (
    <>{chooser(props)}</>
  );
};

export default FullScreenDialog;
